import React from 'react';
import { Box, Flex, Inline, xcss } from '@atlaskit/primitives';
var labelStyles = xcss({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%'
});
/**
 * Renders a icon and text label.
 * If the text is undefined, will not render the text label.
 */
export function SharedIconComponentOld(_ref) {
  var iconUrl = _ref.iconUrl,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    text = _ref.text,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Flex, {
    gap: "space.100",
    alignItems: "center",
    testId: testId
  }, /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement("img", {
    src: iconUrl,
    alt: label
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      minWidth: '24px',
      maxWidth: '24px'
    } // having just width: '24px' shrinks it when table width is reduced
  })), text && /*#__PURE__*/React.createElement(Box, {
    xcss: labelStyles,
    testId: "".concat(testId, "-text")
  }, text));
}